/**
 * @public
 */
export class PluginReader {
    constructor(namespace) {
        this.ns = namespace;
        // name to read the plugin definition string from the dataset API
        this.pluginAttrName = `${this.ns}${this.ns.length > 0 ? "P" : "p"}lugins`;
        this.querySelector = this.buildQuerySelector();
    }
    findAll(element) {
        // query all elements with plugin definitions and convert from NodeList to Array
        return Array.prototype.slice.call(element.querySelectorAll(this.querySelector));
    }
    /**
     * Reads a plugin definition from the given element. But it doesn't parse the definition or validate if it is a valid plugin definition
     *
     * @param element - the element to read the plugin definition from
     *
     * throws an Error if the plugin definition wasn't found
     */
    readDefinition(element) {
        const def = element.dataset[this.pluginAttrName];
        if (!def) {
            throw new Error("No plugin definition found on element.");
        }
        return def;
    }
    /**
     * Reads the parameter for the plugin with the given name from the given element
     *
     * @remarks
     *
     * e.g.:
     * html:
     * ``` html
     *  <div data-plugins="p1" data-p1-foo="bar" data-p1-some-key="value">...</div>
     * ```
     *
     * ``` js
     * readPluginParameter(div, 'p1') returns: { foo: "bar", someKey: "value" }
     * ```
     *
     * @param element - element to read the parameter from
     * @param name - name from the plugin, to read the parameter for
     *
     * @returns plugin parameter object. will be an empty object if no parameters found
     */
    readParameter(element, name) {
        let n = name;
        // concat namespace with plugin name. To read the values from the dataset API, the first char must transformed to upper case.
        if (this.ns.length > 0) {
            n = `${this.ns}${name.charAt(0).toUpperCase()}${name.substring(1)}`;
        }
        // iterate over all available data attributes
        return (Object.keys(element.dataset)
            // keep only values that starts with the (optional namespace +) plugin name
            .filter(k => k.indexOf(n) === 0)
            // create a plugin parameter object for every single key
            .map(k => {
            const key = k.substring(n.length);
            return {
                [key.charAt(0).toLowerCase() + key.substring(1)]: element.dataset[k] || ""
            };
        })
            .reduce((prev, current) => (Object.assign({}, prev, current)), {}));
    }
    buildQuerySelector() {
        const arr = ["data"];
        if (this.ns.length > 0) {
            arr.push(this.ns);
        }
        arr.push("plugins");
        return `[${arr.join("-")}]`;
    }
}
//# sourceMappingURL=PluginReader.js.map